import {
  ContractActionsService,
  type ContractActionV1Dto,
  type CreateContractActionV1Dto,
  PatchContractActionStatusV1Dto,
  type PatchContractActionV1Dto,
  type PatchPositionsListV1Dto,
} from '@/openapi';
import { eventBus } from '@/configs/eventBus';

import type { ContractActionSimple } from '../contractActionTypes';

export function useContractActions() {
  const fetchContractAction = async (id: string) => {
    try {
      return await ContractActionsService.contractActionControllerV1FindOneV1(id);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchContractActions = async () => {
    try {
      return await ContractActionsService.contractActionControllerV1FindAllV1();
    } catch (err) {
      console.log(err);
    }
  };

  const fetchContractActionsByContract = async (contractId: string) => {
    try {
      return await ContractActionsService.contractActionControllerV1FindManyByContractIdV1(
        contractId,
      );
    } catch (err) {
      console.log(err);
    }
  };

  const createContractAction = async (data: CreateContractActionV1Dto) => {
    try {
      await ContractActionsService.contractActionControllerV1CreateV1(data);
      eventBus.emit('create');
    } catch (err) {
      console.log(err);
    }
  };

  const updateContractAction = async (id: string, data: PatchContractActionV1Dto) => {
    try {
      await ContractActionsService.contractActionControllerV1UpdatePartialV1(id, data);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const updateContractActionStatus = async (id: string, data: PatchContractActionStatusV1Dto) => {
    try {
      await ContractActionsService.contractActionControllerV1UpdatePartialStatusV1(id, data);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteContractAction = async (id: string) => {
    try {
      await ContractActionsService.contractActionControllerV1RemoveOneV1(id);
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteContractActions = async (ids: string[]) => {
    try {
      await ContractActionsService.contractActionControllerV1RemoveManyV1({ values: ids });
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * 🔹 **Neue Methode:** Aktualisiert die Reihenfolge von Contract Actions eines Contracts
   */
  const updateContractActionsOrder = async (
    contractId: string,
    positions: PatchPositionsListV1Dto,
  ) => {
    try {
      const updatedActions =
        await ContractActionsService.contractActionControllerV1UpdatePositionsV1(
          contractId,
          positions,
        );
      eventBus.emit('updatePosition');
      return updatedActions;
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchContractAction,
    fetchContractActions,
    fetchContractActionsByContract,
    createContractAction,
    updateContractAction,
    deleteContractAction,
    deleteContractActions,
    updateContractActionsOrder,
    updateContractActionStatus,
  };
}

export function useContractActionsConverter() {
  const convertContractActionDtoToContractActionSimple = (
    item: ContractActionV1Dto,
  ): ContractActionSimple => {
    const { createdAt: _createdAt, modifiedAt: _modifiedAt, ...res } = item;
    return { ...res };
  };

  const convertContractActionDtoListToContractActionSimpleList = (
    data: ContractActionV1Dto[],
  ): ContractActionSimple[] => {
    return data.map((item) => {
      return convertContractActionDtoToContractActionSimple(item);
    });
  };

  const convertContractActionSimpleToCreateContractActionDto = (
    data: ContractActionSimple,
  ): CreateContractActionV1Dto => {
    const {
      id: _id,
      version: _version,
      status: _status,
      numberOfUses: _numberOfUses,
      ...res
    } = data;

    return res;
  };

  const convertContractActionSimpleToUpdateContractActionDto = (
    data: ContractActionSimple,
  ): PatchContractActionV1Dto => {
    const { id: _id, status: _status, numberOfUses: _numberOfUses, ...res } = data;

    return res;
  };

  return {
    convertContractActionDtoToContractActionSimple,
    convertContractActionDtoListToContractActionSimpleList,
    convertContractActionSimpleToCreateContractActionDto,
    convertContractActionSimpleToUpdateContractActionDto,
  };
}
